import { ADD_APP_REVIEW_DATA, UPDATE_APP_REVIEW_DATA } from "../../actionTypes/appReview";

export function addAppReviewData({
  email,
  userReview,
  dateCreated,
  dateUpdated,
  nextRunDays,
}: any) {
  return {
    type: ADD_APP_REVIEW_DATA,
    payload: { email, userReview, dateCreated, dateUpdated, nextRunDays },
  };
}

export function updateAppReviewData({ userReview, dateCreated, dateUpdated }: any) {
  return { type: UPDATE_APP_REVIEW_DATA, payload: { userReview, dateCreated, dateUpdated } };
}
